<!-- 
Standard page heading.
-->
<template>
  <v-container fluid class="pa-0">
    <v-layout row>
      <v-flex grow>
        <v-breadcrumbs v-if="hasBreadcrumbs" :items="breadcrumbs" class="mt-0 mb-1 ml-0 pa-0">
          <template v-slot:divider>
            <v-icon>chevron_right</v-icon>
          </template>
          <template v-slot:item="props">
            <router-link v-if="props.item.path" :to="props.item.path">{{ props.item.text }}</router-link>
            <span v-else>{{ props.item.text }}</span>
          </template>
        </v-breadcrumbs>
      </v-flex>
      <v-flex shrink>
        <slot name="additional-nav"/>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex>
        <h1>
          <slot name="prefix"/>
          <span>{{ title }}</span>
          <span v-if="subtitle && subtitleTooltip == null" class="subheading ml-2">{{ subtitle }}</span>
          <v-tooltip v-if="subtitle && subtitleTooltip" top>
            <span slot="activator" class="subheading ml-2">{{ subtitle }}</span>
            <span>{{ subtitleTooltip }}</span>
          </v-tooltip>
          <our-user-guide-button v-if="userGuideTopic" :topic="userGuideTopic" :section="userGuideSection" in-title />
        </h1>
      </v-flex>
      <v-spacer />
      <v-flex v-if="navUrl" class="text-sm-right">
        <our-next-previous-navigator 
          v-if="arrivedFromListing"
          :module="module" 
          :nav-url="navUrl" 
          :next-page-action="nextPageAction"
          :previous-page-action="previousPageAction"
        />
      </v-flex>
      <slot name="navigator"/>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      validator: prop => typeof prop === "number" || typeof prop === "string" || prop === null,
      default: null
    },
    subtitleTooltip: {
      type: String,
      default: null
    },
    userGuideTopic: {
      type: String,
      default: ""
    },
    userGuideSection: {
      type: String,
      default: ""
    },
    idField: {
      type: String,
      default: "id"
    },
    module: {
      type: String,
      default: ""
    },
    navUrl: {
      type: String,
      default: ""
    },
    nextPageAction: {
      type: String,
      default: ""
    },
    previousPageAction: {
      type: String,
      default: ""
    },
    arrivedFromListing: {
      type: Boolean,
      default: false
    },
    breadcrumbs: {
      type: Array,
      default: null
    }
  },
  computed: {
    hasBreadcrumbs() {
      return this.breadcrumbs && this.breadcrumbs.length > 0;
    },
    hasNavigatorSlot() {
      return !!this.$slots["navigator"];
    }
  }
};
</script>
